(function () {
    "use strict";

    angular.module("showcaseApp").component("filterDateRange", {
        templateUrl: "app/components/filter-date-range/filter-date-range.html",
        controller: filterDateRangeController,
        bindings: {
            name: "@",
            inputType: '@?',
            placeholder: "@",
            modelStartDate: "=",
            modelEndDate: "=",
            leftPosition: '=',
            fullscreen: "=",
            actionOnClose: "&?",
        },
    });

    /** @ngInject */
    function filterDateRangeController(
        $translate,
        $element,
        $timeout,
        moment,
        $scope,
        systemConstants,
        $window
    ) {
        var $ctrl = this;

        var DATE_FORMAT = $translate.instant('momentDateFormat');

        var inputTypes = ['button', 'field'];
        var defaultInputType = 'button';

        $ctrl.TRUNCATE_THRESHOLD = 35;
        $ctrl.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MIN_SM;

        $ctrl.startDateName = $ctrl.name + '-startDate';
        $ctrl.endDateName = $ctrl.name + '-endDate';
        $ctrl.appliedStartDate = null;
        $ctrl.appliedEndDate = null;

        function resetDates() {
            $ctrl.modelStartDate = undefined;
            $ctrl.modelEndDate = undefined;

            $timeout(function () {
                var startDateInput = angular
                    .element('[name="' + $ctrl.startDateName + '"]')
                    .find("input");
                var endDateInput = angular
                    .element('[name="' + $ctrl.endDateName + '"]')
                    .find("input");

                if (startDateInput.length) {
                    startDateInput.val("");
                }
                if (endDateInput.length) {
                    endDateInput.val("");
                }

                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            });
            $scope.$broadcast('resetDates');
        }

        $ctrl.isSelected = function () {
            if (!$ctrl.actionOnClose) {
                if (!$ctrl.modelStartDate || !$ctrl.modelEndDate) {
                    return false;
                }
                var start = moment($ctrl.modelStartDate, DATE_FORMAT, true);
                var end   = moment($ctrl.modelEndDate, DATE_FORMAT, true);
                return start.isValid() && end.isValid() && !start.isAfter(end);
            }

            return ($ctrl.appliedStartDate && $ctrl.appliedEndDate);
        };

        $ctrl.getPlaceholderText = function () {
            return (
                $translate.instant($ctrl.placeholder) +
                ($ctrl.isSelected() ? " | " : "")
            );
        };

        function updateSelectedText() {
            if (!$ctrl.isSelected()) {
                $ctrl.selectedText = "";
                return;
            }

            var start, end;

            if (!$ctrl.actionOnClose) {
                start = moment($ctrl.modelStartDate, DATE_FORMAT);
                end   = moment($ctrl.modelEndDate, DATE_FORMAT);
            } else {
                start = moment($ctrl.appliedStartDate, DATE_FORMAT);
                end   = moment($ctrl.appliedEndDate, DATE_FORMAT);
            }

            var txt = start.format(DATE_FORMAT) + " - " + end.format(DATE_FORMAT);

            if (txt.length > $ctrl.TRUNCATE_THRESHOLD) {
                txt = txt.substring(0, $ctrl.TRUNCATE_THRESHOLD) + "...";
            }

            $ctrl.selectedText = txt;
        }

        $ctrl.clearSelection = function ($event) {
            $event.stopPropagation();
            resetDates();
            $ctrl.appliedStartDate = null;
            $ctrl.appliedEndDate = null;
            if ($ctrl.actionOnClose) {
                $timeout(function () {
                    $ctrl.actionOnClose();
                }, 0);
            }

            updateSelectedText();
        };

        $element.on('hidden.bs.dropdown', function () {
            var start = $ctrl.modelStartDate;
            var end = $ctrl.modelEndDate;

            if (!start && !end) {
                return;
            }

            if (!start || !end) {
                showFormErrors();
                return;
            }

            var startDate = moment(start, DATE_FORMAT, true);
            var endDate = moment(end, DATE_FORMAT, true);

            if (!startDate.isValid() || !endDate.isValid() || startDate.isAfter(endDate)) {
                showFormErrors();
                return;
            }

            if ($ctrl.actionOnClose) {
                $ctrl.appliedStartDate = $ctrl.modelStartDate;
                $ctrl.appliedEndDate = $ctrl.modelEndDate;

                $ctrl.actionOnClose();
            } else {
                $ctrl.appliedStartDate = $ctrl.modelStartDate;
                $ctrl.appliedEndDate = $ctrl.modelEndDate;
            }

            updateSelectedText();
        });

        $ctrl.$onInit = function () {
            if (!$ctrl.inputType || !inputTypes.includes($ctrl.inputType)) {
                $ctrl.inputType = defaultInputType;
            }

            if ($ctrl.modelStartDate && $ctrl.modelEndDate) {
                var start = moment($ctrl.modelStartDate, DATE_FORMAT, true);
                var end   = moment($ctrl.modelEndDate, DATE_FORMAT, true);

                if (start.isValid() && end.isValid() && !start.isAfter(end)) {
                    $ctrl.appliedStartDate = $ctrl.modelStartDate;
                    $ctrl.appliedEndDate   = $ctrl.modelEndDate;
                }
            }
            updateSelectedText();
        };

        $scope.$watchGroup(['$ctrl.modelStartDate', '$ctrl.modelEndDate'], function (newVals) {
            var start = newVals[0];
            var end   = newVals[1];

            updateSelectedText();

            if ((!start || !end) && $ctrl.actionOnClose) {
                $ctrl.appliedStartDate = null;
                $ctrl.appliedEndDate   = null;
            }
        });


        function showFormErrors() {
            var form = $ctrl.dateRangeForm;
            var startField = form && form[$ctrl.startDateName];
            var endField = form && form[$ctrl.endDateName];

            if (startField) {
                startField.$setTouched();
            }
            if (endField) {
                endField.$setTouched();
            }

            if (!$ctrl.actionOnClose) {
                $ctrl.modelStartDate = null;
                $ctrl.modelEndDate = null;
            }
        }
    }
})();
